import axios from "axios";
import { RESPONSE_STATUS } from "@/constants/request";
import { AUTH_STORAGE_KEY } from "@/config";
import { getWindowId, getBaseURL } from "@/utils/utils";
import { CUSTOM_HEADER } from "@/constants";

const baseURL = getBaseURL();

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

const instance = axios.create({
  baseURL,
  headers,
  timeout: 0,
  withCredentials: true,
  maxRedirects: 0,
});

instance.interceptors.request.use((config) => {
  if (config.method.toUpperCase() !== "GET") {
    const actionType = localStorage.getItem(CUSTOM_HEADER.ACTION_TYPE);
    if (actionType) {
      config.headers[CUSTOM_HEADER.ACTION_TYPE] = actionType;

      const fullUrl = new URL(config.url, config.baseURL);
      const params = Object.fromEntries(fullUrl.searchParams.entries());
      if (params.cur_step === params.last_step) {
        localStorage.removeItem(CUSTOM_HEADER.ACTION_TYPE);
      }
    }
  }

  const authorization = localStorage.getItem(AUTH_STORAGE_KEY);
  if (authorization) {
    config.headers["Authorization"] = `Bearer ${
      JSON.parse(authorization).token
    }`;
  }

  config.headers[CUSTOM_HEADER.WINDOW_ID] = getWindowId();
  config.headers["Window-Id"] = getWindowId();

  const params = new URLSearchParams(window.location.search);

  if (params.get("lang")) {
    config.params = {
      ...config.params,
      display_lang: params.get("lang"),
    };

    if (!config.params?.lang) {
      config.params.lang = params.get("lang");
    }
  }

  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response?.status === RESPONSE_STATUS.UNAUTHORIZED &&
      localStorage.getItem(AUTH_STORAGE_KEY)
    ) {
      localStorage.clear();
      location.reload();
    }
    return Promise.reject(error);
  }
);

const authHeaders = () => {
  const authStorage = JSON.parse(localStorage.getItem(AUTH_STORAGE_KEY)) || {};
  return {
    Authorization: `Bearer ${authStorage.token}`,
    "Cache-Control": "no-cache",
  };
};

export const post = (endpoint, data = {}) => {
  return instance({
    method: "POST",
    url: endpoint,
    data,
    headers: authHeaders(),
  });
};

export default instance;
